
















import { defineComponent } from "@vue/composition-api";
import useOnChangePage from "@/hooks/useOnChangePage";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "PaidActionError",
  components: { BaseIcon, BaseButton, BaseConfirm, FormatMoney },
  props: {
    value: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const onAddMoney = () => {
      emitter.emit(EVENTS.BALANCE_REFILL_SHOW);
      emit("input", false);
    };

    const onClose = () => {
      emit("input", false);
    };

    useOnChangePage(onClose);

    return {
      onAddMoney,
      onClose,
    };
  },
});
